const Contact = ({ configs }) => {
  return (
    <div className="contactUsApp">
      <div style={{ backgroundColor: "transparent", marginBottom: "10px" }}>
        <div className="rowtab">
          <i className="fa fa-map-marker"></i>

          <a
            href="https://maps.app.goo.gl/d3fPk9QEK5WXFyYLA"
            // "https://goo.gl/maps/YCccKwV89X9cboR36"
            target="_blank"
            rel="noreferrer"
          >
            {configs.length !== 0
              ? configs?.address
              : "بلوار اندرزگو نبش اشکستانپور شمالی - پلاک 6"}
          </a>
        </div>
        <div className="rowtab">
          <a
            target="_blank"
            rel="noreferrer"
            href={`https://t.me/${
              configs.length !== 0 ? configs?.telegram : "Smojtahediexchange"
            }`}
          >
            <i className="fa fa-telegram"></i>
            {configs.length !== 0 ? configs?.telegram : "Smojtahediexchange"}
          </a>
        </div>
        <div className="rowtab">
          <a
            target="_blank"
            rel="noreferrer"
            href={`https://www.instagram.com/${
              configs.length !== 0
                ? configs?.instagram
                : "mojtahedi_exchange/?igshid=j5l3vzwturib"
            }`}
          >
            <i className="fa fa-instagram"></i>
            {configs.length !== 0 ? configs?.instagram : "mojtahedi_exchange"}
          </a>
        </div>

        <div className="rowtab">
          <i className="fa fa-phone"></i>
          <a href={`tel:${configs.length !== 0 ? configs?.phone : "021-26655661"}`}>
            &#x200E;
            {configs.length !== 0 ? configs?.phone : "021-26655661"}
          </a>
        </div>
      </div>
    </div>
  );
};
export default Contact;
